export default "__VITE_ASSET__CnqoERJC__"